import React, { useContext } from "react";
import TildeOkCircle from "../../../assets/images/generico/TildeOkCircle";
import { PortalContext } from "../../../context/Provider";
import "./LoginLeftPanel.css";

const LoginLeftPanel = () => {
  const { textosState } = useContext(PortalContext);

  return (
    <React.Fragment>
      <div className="ptur-loginLeftPanel-beneficios">
        <img
          className="ptur-loginLeftPanel-logo"
          src={process.env.PUBLIC_URL + "/assets/images/empresa/IsoLogo.png"}
          alt="logo"
        ></img>
        {textosState.textos.data &&
          Array.from(textosState.textos.data.beneficios).map((item, index) => {
            return (
              <React.Fragment key={index}>
                <TildeOkCircle
                  texto={item.descripcion}
                  colorTilde="var(--color-white)"
                  colorTexto="c-white"
                />
              </React.Fragment>
            );
          })}
      </div>
    </React.Fragment>
  );
};

export default LoginLeftPanel;
